<template>
    <div class="layout-page">
         <div  style="min-height: 350px;">
            <h1>Page Not Found</h1>

            <p>
               Oops! It looks like the page you were looking for was not found.
            </p>
         </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>